export default {"src":"/_next/static/media/Brain Tumors.4db61005.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};